import React from "react";
import { EmptyState } from "@jsq/ds/core";
import { Section, CustomField } from "../../types";
import SectionDisplay from "../SectionDisplay";

export type SectionWithFields = {
  section: Section;
  fields: CustomField[];
};

export type SectionsViewProps = {
  sectionsWithFields: SectionWithFields[];
  onEditField: (field: CustomField) => void;
  onDeleteField: (field: CustomField) => void;
};

export const SectionsView: React.FC<SectionsViewProps> = ({
  sectionsWithFields,
  onEditField,
  onDeleteField,
}) => {
  return (
    <>
      {/* Display all sections with their fields */}
      {sectionsWithFields.map(({ section, fields }) => (
        <SectionDisplay
          key={section.id}
          section={section}
          fields={fields}
          onEditField={onEditField}
          onDeleteField={onDeleteField}
        />
      ))}

      {/* Show empty state if no sections and no fields */}
      {sectionsWithFields.length === 0 && (
        <EmptyState
          illustration="working-at-table"
          title="No custom fields found"
          description="Please create a custom field to get started."
        />
      )}
    </>
  );
};
